import { WordCloudWrapper } from './wrapper';
import { WordCloudKnobs } from './knobs'
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { propertyHierarchy } from 'widgets/endpoints';
import { filterProperties } from 'utilities/srsUtils';
import { DefaultChartColorScales } from 'styles/chartColors';
import { FONT_FAMILIES, SCALING_FUNCTIONS } from 'widgets/chartUtils';

const flags = [SrsPropertyFlag.Categorical];

export const config = {
	key: 'WORD_CLOUD',
	label: '(alpha) Word Cloud',
	icon: 'cloud',
	wrapper: WordCloudWrapper,
	endpoint: propertyHierarchy,
	Knobs: WordCloudKnobs,
	flags: flags,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					maxRoot: 50,
					maxChildren: 100,
				},
			},
		};
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			colorScale: DefaultChartColorScales.Categorical,
			numOrientations:2,
			minRotate:-90,
			maxRotate:90,
			font:FONT_FAMILIES[0].value,
			sizeScale:SCALING_FUNCTIONS[0].value,
			minFontSize:4,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
